export const environment = {
  production: true,
  apiUrl: 'https://api.cccsympo.sandbox.medinbox.ai/api',
  basicToken: 'bWVkaW5ib3g6TTNkaW5iMHgh',
  cognito: {
    userPoolId: 'eu-west-1_r41b3TOUg',
    userPoolWebClientId: 'vnege7be5ras0mvkphp4tvdj0',
  },
  analytics: {
    enabled: true,
    measurementId: 'G-6Z73JBV5HJ',
  },
};
